// containerFullWidth.js — pure render-side enforcement for GORDON 2026-09-15
// Container block settings pane spec, item 1: "Full Width currently does
// nothing. It must lock the container flush to the segment-card edit edges (0
// left/right margin) ... while active."
//
// `lockedMargin` is called by Container.jsx's own margin-style computation, so
// the flush-to-edges guarantee holds regardless of what is actually stored on
// the node (a pre-existing wheel saved before this fix, a value written through
// any path other than the settings pane, etc.) — a LOCK, not just a UI default.

/**
 * @param {{top?:number,bottom?:number,left?:number,right?:number}|undefined} margin
 * @param {boolean} fullWidth
 * @returns {{top?:number,bottom?:number,left:number,right:number}}
 */
export function lockedMargin(margin, fullWidth) {
  if (!fullWidth) return margin;
  return { ...(margin || {}), left: 0, right: 0 };
}

export default lockedMargin;
